import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './react-19-update.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
